<script>

import {mapActions} from "vuex";

export default {
  name: "ModifyRecycleDisposalReportMethod",
  props: {
    /**
     * マニフェスト（処分報告情報）
     */
    manifest: {
      type: Object,
      default: () => ({}),
    },
    manifestDisposal: {
      type: Object,
      default: () => {},
    },
    canEdit: {
      type: Boolean,
      default: () => false,
    },
    callerType: {
      type: String,
      default: () => null,
    },
  },

  data() {
    return {
      headers: [
        { value: "level", text: "", width: "5%" },
        { value: "disposer", text: "処分業者\r\n処分事業場\r\n住所", width: "20%" },
        { value: "report_before_disposal_weight", text: "処分前重量", width: "10%" },
        { value: "disposal_method", text: "処分方法", width: "20%" },
        { value: "report_after_disposal_weight", text: "処理後重量", width: "10%" },
        { value: "recycle_disposed_item", text: "処理後物の大分類\r\n処理後物の種類", width: "20%" },
        // { value: "input_final_disposal_date", text: "最終処分終了日", width: "14%" },
        { value: "comment", text: "備考", width: "15%", editable: true },
      ],
      patternId: null,
    }
  },
  watch: {
    "manifest.pattern": {
      handler (newValue) {
        // クリア時の一覧初期化は pattern-changed イベント側で実施
        if (!newValue) {
          this.patternId = null;
          return;
        }
        this.patternId = newValue.id;
        this.loadDisposalMethod();
      },
      immediate: true,
      deep: true,
    }
  },
  computed: {
    /**
     * 処理フローの重量合計バリデーションルール。
     * 01工程の処分前重量合計が、基準重量（数量）の90%〜110%に収まることを検証する。
     */
    flowRules () {
      return {
        pmFirstBeforeWeightTotalRange: {
          targetList: this.manifestDisposal.manifest_recycle_disposal_reports || [],
          final_disposal_quantity: this.manifestDisposal.disposal_quantity,
        },
      }
    },
  },
  methods: {
    /**
     * 処理工程選択 再資源化等パターン
     */
    ...mapActions("DriverMasterSearchRecycleDisposalPattern", {
      fetchPattern: "show"
    }),

    loadDisposalMethod () {
      this.fetchPattern({ id: this.patternId, type: 'methods' }).then((content) => {
        this.$set(this.manifestDisposal, 'manifest_recycle_disposal_reports', content.pattern_details || []);
      }).catch(error => {
        console.error('fetchPattern error:', error);
      });
    },
  },
}
</script>

<template>
  <div class="reportLayer">

    <!-- 処理フロー -->
    <validation-provider
      v-slot="{ errors: detailErrors }"
      name="リスト"
      :rules="flowRules"
    >
      <div class="hidden">
        <v-input
          v-model="manifestDisposal"
          :error-messages="detailErrors"
          dense
          outlined
          readonly
          hide-details="auto"
        >
          <template v-slot:message>
            <div class="ml-2">
              <p v-for="(message, index) in detailErrors" :key="index">{{ message }}</p>
            </div>
          </template>
        </v-input>
      </div>
      <recycle-step-table
        :headers="headers"
        :final-disposal-minimum-date="manifest.collected_date"
        :result-list="manifestDisposal.manifest_recycle_disposal_reports || []"
        :editable-mode="!canEdit"
        :reference-only="!canEdit"
        :target-for-registration="canEdit"
        :has-error="detailErrors.length > 0"
        :final-disposal-quantity="manifestDisposal.disposal_quantity"
        :pattern-id="patternId"
        :pattern-type="'methods'"
        :call-source="'disposal'"
      />
    </validation-provider>
    <!-- 処理フロー -->

  </div>
</template>

<style lang="scss">

</style>
